export { default } from './GraficBarraHoritzontal';
